<template>
  <div class="row">
    <div class="col-12">
      <card class="shadow-lg">
        <div class="row content-add-btn">
          <button class="btn btn-secondary" @click="$router.go(-1)">
            <em class="fa fa-chevron-left"></em>
            {{ $t('common_words.exit') }}
          </button>
        </div>
        <hr />
        <form-wizard
          ref="formWizard"
          v-if="this.isCreate() || this.isUpdate()"
          @on-complete="storeUpdateQuality"
          title
          subtitle
          :back-button-text="$t('common_words.back')"
          :next-button-text="$t('common_words.next')"
          :finish-button-text="$t('common_words.save')"
          class="custom-padding-wz-header"
        >
          <tab-content
            :title="$t('common_words.general_information')"
            :before-change="() => validateStep('firstStep')"
          >
            <first-step
              ref="firstStep"
              @on-validated="onStepValidated"
              @fillQualityForm="fillQualityForm"
              @showHideLoading="showHideLoading"
            ></first-step>
          </tab-content>
          <tab-content
            :title="$t('common_words.sub_category_and_tasks')"
            :before-change="() => validateStep('secondStep')"
          >
            <second-step
              ref="secondStep"
              @on-validated="onStepValidated"
              @fillQualityForm="fillQualityForm"
              @showHideLoading="showHideLoading"
            ></second-step>
          </tab-content>
          <tab-content :title="$t('common_words.confirm')">
            <p class="cm-mg-p-wzd text-center text-muted">
              3. {{ $t('common_words.verify_inputed_information') }}
            </p>
            <br />
            <div class="row d-flex justify-content-center">
              <div class="col-11">
                <table class="table">
                  <tbody>
                    <tr class="shadow-sm">
                      <td>
                        <h6>
                          <strong>{{ $t('common_words.name') }}</strong>
                        </h6>
                        {{ qualityForm.name }}
                      </td>
                    </tr>
                    <tr class="shadow-sm">
                      <td>
                        <h6>
                          <strong>{{ $t('common_words.description') }}</strong>
                        </h6>
                        {{ qualityForm.description }}
                      </td>
                    </tr>
                    <tr class="shadow-sm">
                      <td>
                        <h6 class="custom-margin-h6-table">
                          <strong>{{ $t('common_words.type_grade') }}</strong>
                        </h6>
                        <el-tag type="info">{{ qualityForm.type }}</el-tag>
                      </td>
                    </tr>
                    <tr class="shadow-sm">
                      <td>
                        <h6 class="custom-margin-h6-table">
                          <strong>{{
                            $t('common_words.type_of_grade')
                          }}</strong>
                        </h6>
                        <el-tag type="info">{{
                          qualityForm.quality_type_label
                        }}</el-tag>
                      </td>
                    </tr>
                    <tr class="shadow-sm">
                      <td>
                        <h6 class="custom-margin-h6-table">
                          <strong>{{
                            $t('common_words.associated_companies')
                          }}</strong>
                        </h6>
                        <span
                          v-for="(business, index) in qualityForm.business_name"
                          :key="index"
                        >
                          <el-tag type="info">{{ business }}</el-tag>
                        </span>
                      </td>
                    </tr>
                    <tr class="shadow-sm">
                      <td>
                        <h6 class="custom-margin-h6-table">
                          <strong>{{
                            $t('common_words.associated_profiles2')
                          }}</strong>
                        </h6>
                        <span
                          v-for="(role, index) in qualityForm.roles_name"
                          :key="index"
                        >
                          <el-tag type="info">{{ role }}</el-tag>
                        </span>
                      </td>
                    </tr>
                    <tr class="shadow-sm">
                      <td>
                        <h6 class="custom-margin-h6-table">
                          <strong>{{
                            $t('common_words.associated_users2')
                          }}</strong>
                        </h6>
                        <span
                          v-for="(user, index) in qualityForm.users_name"
                          :key="index"
                        >
                          <el-tag type="info">{{ user }}</el-tag>
                        </span>
                      </td>
                    </tr>
                    <tr class="shadow-sm">
                      <td>
                        <h6 class="custom-margin-h6-table">
                          <strong>{{
                            $t('common_words.sub_associated_category')
                          }}</strong>
                        </h6>
                        <div
                          v-if="
                            qualityForm.sub_category_names &&
                            qualityForm.sub_category_names.length > 0
                          "
                          class="row table"
                        >
                          <div class="col-2 border-bottom pd-3"></div>
                          <div class="col-10 border-bottom pl-1 pd-3">
                            <div class="row">
                              <div
                                class="col-3 mt-2 pl-0 pb-2 text-muted fs-12"
                              >
                                {{ $t('common_words.task') }}
                              </div>
                              <div
                                class="col-2 mt-2 pl-1 pb-2 text-muted fs-12"
                              >
                                {{ $t('common_words.type') }}
                              </div>
                              <div
                                class="col-3 mt-2 pl-1 pb-2 text-muted fs-12"
                              >
                                {{ $t('common_words.mayus_associated_value') }}
                              </div>
                              <div
                                class="col-2 mt-2 pl-2 pb-2 text-muted fs-12"
                              >
                                {{ $t('common_words.photo_questionmark') }}
                              </div>
                              <div
                                class="col-2 mt-2 pl-2 pb-2 text-muted fs-12"
                              >
                                {{ $t('common_words.required_questionmark') }}
                              </div>
                            </div>
                          </div>
                        </div>
                        <div
                          class="row table border-bottom mt-0"
                          v-for="(index, order) in orderData(
                            qualityForm.subcategoryOrder
                          )"
                          :key="order"
                        >
                          <div class="col-2 pl-0">
                            <el-tag
                              type="info"
                              v-if="qualityForm.sub_category_names[index]"
                            >
                              <span
                                v-tooltip.top-center="
                                  qualityForm.sub_category_names[index].length >
                                  15
                                    ? `${order} - ${qualityForm.sub_category_names[index]}`
                                    : ``
                                "
                              >
                                {{ order }} -
                                {{
                                  qualityForm.sub_category_names[
                                    index
                                  ].substring(0, 15)
                                }}{{
                                  qualityForm.sub_category_names[index].length >
                                  15
                                    ? `...`
                                    : ``
                                }}
                              </span>
                            </el-tag>
                          </div>
                          <div class="col-10 pl-1 pr-0">
                            <div class="row">
                              <div
                                class="body-info-table col-3 text-break pl-1 pr-1"
                              >
                                <template
                                  v-for="(taskIndex, order) in orderData(
                                    getOrderTask(index)
                                  )"
                                >
                                  <p
                                    class="d-flex align-items-center border-bottom size-cell"
                                    v-if="qualityForm.task_names[taskIndex]"
                                    :key="order"
                                  >
                                    {{ order }}
                                    -
                                    {{ qualityForm.task_names[taskIndex] }}
                                  </p>
                                </template>
                              </div>
                              <div
                                class="body-info-table col-2 text-break pl-0 pr-1"
                              >
                                <template
                                  v-for="(taskIndex, order) in orderData(
                                    getOrderTask(index)
                                  )"
                                >
                                  <p
                                    v-if="
                                      qualityForm.calification_type[taskIndex]
                                    "
                                    class="d-flex align-items-center border-bottom size-cell"
                                    :key="order"
                                  >
                                    {{
                                      qualityForm.calification_type[taskIndex]
                                    }}
                                  </p>
                                </template>
                              </div>
                              <div
                                class="body-info-table col-3 text-break pl-0 pr-1 fs-12"
                              >
                                <template
                                  v-for="(taskIndex, order) in orderData(
                                    getOrderTask(index)
                                  )"
                                >
                                  <p
                                    v-tooltip.top-center="
                                      showOptionTask(
                                        qualityForm.task_values[taskIndex]
                                      ).length > 60
                                        ? showOptionTask(
                                            qualityForm.task_values[taskIndex]
                                          )
                                        : ``
                                    "
                                    class="d-flex align-items-center border-bottom size-cell"
                                    :key="order"
                                    v-if="
                                      qualityForm.task_values[taskIndex] &&
                                      qualityForm.calification_type[
                                        taskIndex
                                      ] &&
                                      ['Única', 'Múltiple'].includes(
                                        qualityForm.calification_type[taskIndex]
                                      )
                                    "
                                  >
                                    {{
                                      showOptionTask(
                                        qualityForm.task_values[taskIndex]
                                      ).substring(0, 60)
                                    }}
                                    {{
                                      showOptionTask(
                                        qualityForm.task_values[taskIndex]
                                      ).length > 60
                                        ? `...`
                                        : ``
                                    }}
                                  </p>
                                  <p
                                    class="d-flex align-items-center border-bottom size-cell"
                                    v-else-if="
                                      qualityForm.calification_type[
                                        taskIndex
                                      ] == 'Subjetiva'
                                    "
                                  >
                                    <label class="row subject-calification">
                                      <div class="px-0 mr-1">
                                        <el-tag closable type="info">
                                          0
                                        </el-tag>
                                      </div>
                                      ...
                                      <div class="px-0 mr-1">
                                        <el-tag closable type="info">
                                          10
                                        </el-tag>
                                      </div>
                                      ...
                                      <div class="px-0 mr-1">
                                        <el-tag closable type="info">
                                          NA
                                        </el-tag>
                                      </div>
                                    </label>
                                  </p>
                                  <p
                                    class="d-flex align-items-center border-bottom size-cell"
                                    v-else-if="
                                      ['Numérica', 'Texto'].includes(
                                        qualityForm.calification_type[taskIndex]
                                      )
                                    "
                                  >
                                    <label
                                      class="font-weight-light"
                                      style="font-size: 14px"
                                    >
                                      {{ showRangeSelected(taskIndex) }}
                                    </label>
                                  </p>
                                  <p
                                    class="d-flex align-items-center border-bottom size-cell"
                                    v-else-if="
                                      qualityForm.task_values[taskIndex] &&
                                      qualityForm.calification_type[
                                        taskIndex
                                      ] &&
                                      [
                                        'Fuente de Datos',
                                        'Fuente de Datos Múltiple',
                                      ].includes(
                                        qualityForm.calification_type[taskIndex]
                                      )
                                    "
                                  >
                                    {{
                                      qualityForm.data_source_selected[
                                        taskIndex
                                      ]
                                    }}
                                  </p>
                                  <p
                                    class="d-flex align-items-center border-bottom size-cell"
                                    v-else-if="
                                      ['Numérica', 'Texto'].includes(
                                        qualityForm.calification_type[taskIndex]
                                      )
                                    "
                                  >
                                    <label
                                      class="font-weight-light"
                                      style="font-size: 14px"
                                    >
                                      {{ showRangeSelected(taskIndex) }}
                                    </label>
                                  </p>
                                  <p
                                    class="d-flex align-items-center border-bottom size-cell"
                                    v-else-if="
                                      ['Fecha', 'Hora', 'Objetiva'].includes(
                                        qualityForm.calification_type[taskIndex]
                                      )
                                    "
                                  >
                                    {{ $t('common_words.does_not_apply') }}
                                  </p>
                                </template>
                              </div>
                              <div
                                class="body-info-table col-2 text-break pl-0 pr-1"
                              >
                                <template
                                  v-for="(taskIndex, order) in orderData(
                                    getOrderTask(index)
                                  )"
                                >
                                  <p
                                    v-if="
                                      qualityForm.photo_required[taskIndex] !==
                                      undefined
                                    "
                                    class="d-flex align-items-center border-bottom size-cell"
                                    :key="order"
                                  >
                                    {{
                                      qualityForm.photo_required[taskIndex]
                                        ? 'Si'
                                        : 'No'
                                    }}
                                  </p>
                                </template>
                              </div>
                              <div
                                class="body-info-table col-2 text-break pl-0 pr-1"
                              >
                                <template
                                  v-for="(taskIndex, order) in orderData(
                                    getOrderTask(index)
                                  )"
                                >
                                  <p
                                    v-if="
                                      qualityForm.is_required[taskIndex] !==
                                      undefined
                                    "
                                    class="d-flex align-items-center border-bottom size-cell"
                                    :key="order"
                                  >
                                    {{
                                      qualityForm.is_required[taskIndex]
                                        ? 'Si'
                                        : 'No'
                                    }}
                                  </p>
                                </template>
                              </div>
                            </div>
                          </div>
                        </div>
                        <el-tag
                          type="warning"
                          v-if="
                            !qualityForm.sub_category_names ||
                            qualityForm.sub_category_names.length == 0
                          "
                          >{{
                            $t('common_words.no_sub_associated_category')
                          }}</el-tag
                        >
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </tab-content>
        </form-wizard>
        <div v-else>
          <br />
          <h5 class="text-muted text-center">
            {{ $t('common_words.no_permissions_operations') }}
          </h5>
        </div>
      </card>
    </div>
  </div>
</template>
<script>
import FirstStep from './steps/FirstStep.vue';
import SecondStep from './steps/SecondStep.vue';
import MixinPermissions from 'src/util/mixinPermissions';
import MixinNumbers from 'src/util/mixinNumbers';
import MixinMasters from 'src/util/mixinMasters';
import { Slider } from 'element-ui';
import { Axios } from 'src/class/Axios.js';
import { showContinue } from 'src/util/Util.js';
import MixinMenu from 'src/util/mixinMenu';

export default {
  components: {
    FirstStep,
    SecondStep,
    [Slider.name]: Slider,
  },

  data() {
    return {
      title: '',
      qualityForm: {
        name: null,
        description: null,
        catch_type: null,
        quality_type: 'web',
        business_name: null,
        sub_category_ids: [],
        subcategoryOrder: [],
        sub_category_names: [],
        task_ids: [],
        task_names: [],
        task_order: [],
      },
      wizardModel: {},
    };
  },

  mixins: [MixinPermissions, MixinMasters, MixinNumbers, MixinMenu],

  methods: {
    showOptionTask(items) {
      return `["${items.join('", "')}"]`;
    },

    orderData(data) {
      let array = [];
      try {
        array = Object.entries(data);
      } catch (error) {
        //
      }

      array.sort((a, b) => a[1] - b[1]);
      const sortedObj = Object.fromEntries(
        array.map(([value, key]) => [key, value])
      );

      return sortedObj;
    },

    getOrderTask(indexSubcategory) {
      let a = 0;
      const response = [];
      while (a < this.qualityForm.tasks_number[indexSubcategory]) {
        response.push(`${indexSubcategory}-${a}`);
        a++;
      }

      response.sort((a, b) => a - b);

      const array = Object.entries(this.qualityForm.task_order);
      const orderTask = {};
      array.forEach((data) => {
        if (response.includes(data[0])) {
          orderTask[data[0]] = data[1];
        }
      });

      return orderTask;
    },

    cleanAllSteps() {
      this.$refs.firstStep.model = {
        ...this.$refs.firstStep.initialModel,
        total_records: 1,
        quality_type: 'web',
      };
      this.$refs.secondStep.cleanStep();
    },

    showRangeSelected(index) {
      try {
        return (
          'Min: ' +
          this.roundNumber(this.qualityForm.task_numeric_values[index][0], 2) +
          ' - Max: ' +
          this.roundNumber(this.qualityForm.task_numeric_values[index][1], 2)
        );
      } catch (error) {
        return '';
      }
    },

    validateStep(ref) {
      return this.$refs[ref].validate();
    },

    onStepValidated(validated, model) {
      this.wizardModel = { ...this.wizardModel, ...model };
    },

    fillQualityForm(ref, others) {
      this.qualityForm = Object.assign(
        {},
        this.qualityForm,
        this.$refs[ref].model
      );

      if (others)
        this.qualityForm = Object.assign({}, this.qualityForm, others);
    },

    storeUpdateQuality() {
      this.showHideLoading(true);
      this.qualityForm.route = 'quality/quality';
      if (sessionStorage.getItem('editForm')) {
        if (this.isUpdate()) {
          this.qualityForm.id = JSON.parse(
            sessionStorage.getItem('editForm')
          ).id;
          Axios.updateMaster(this.qualityForm)
            .then((response) => {
              this.showHideLoading();
              showContinue(
                this,
                response.data.message ? response.data.message : response.errors,
                '/quality/quality',
                null
              );
            })
            .catch((error) => this.showMessageErrors(error));
        } else {
          this.showMessageAccess();
          this.showHideLoading();
        }
      } else {
        if (this.isCreate()) {
          Axios.saveMaster(this.qualityForm)
            .then((response) => {
              this.showHideLoading();
              showContinue(
                this,
                response.data.message ? response.data.message : response.errors,
                '/quality/quality',
                null
              );
            })
            .catch((error) => this.showMessageErrors(error));
        } else {
          this.showMessageAccess();
          this.showHideLoading();
        }
      }
    },
  },

  mounted() {
    this.selectedItemOnMenu('quality');
  },

  beforeDestroy() {
    sessionStorage.removeItem('editForm');
    this.deselectedItemOnMenu('quality');
  },
};
</script>
<style></style>
